import {
    BuildingA1Parking1,
    BuildingA1Floor1,
    BuildingA1Floor2,
    BuildingA1Floor3,
    BuildingA1Floor4,
    BuildingA1Floor5,
    BuildingA1Floor6,
    BuildingA1Floor7,
    BuildingA1Floor8,

    BuildingA1Parking1Select,
    BuildingA1Floor1Select,
    BuildingA1Floor2Select,
    BuildingA1Floor3Select,
    BuildingA1Floor4Select,
    BuildingA1Floor5Select,
    BuildingA1Floor6Select,
    BuildingA1Floor7Select,
    BuildingA1Floor8Select,
    sold_en, sold_hy, sold_ru,

} from "../assets/images";

export const BUILDINGS_SLUG = 'A1'
export const BUILDINGS_KEYS = {
    A: "A1",
}

export const AREA_REDIRECT_TYPES = {
    "66d8270c6c6ee6f56c12f328": {
        floor:1,
        id:"66d826d46c6ee6f56c12f2e8",
    },
}

export const floorsImages = {
    "A1_-1": BuildingA1Parking1,
    A1_1: BuildingA1Floor1,
    A1_2: BuildingA1Floor2,
    A1_3: BuildingA1Floor3,
    A1_4: BuildingA1Floor4,
    A1_5: BuildingA1Floor5,
    A1_6: BuildingA1Floor6,
    A1_7: BuildingA1Floor7,
    A1_8: BuildingA1Floor8,
}
export const floorsSelect = {
    "A1_-1": BuildingA1Parking1Select,
    A1_1: BuildingA1Floor1Select,
    A1_2: BuildingA1Floor2Select,
    A1_3: BuildingA1Floor3Select,
    A1_4: BuildingA1Floor4Select,
    A1_5: BuildingA1Floor5Select,
    A1_6: BuildingA1Floor6Select,
    A1_7: BuildingA1Floor7Select,
    A1_8: BuildingA1Floor8Select,
}

export const HYPOTHEC_TERM_TYPES = {
    MONTH: 'calculator_hypothec_type_mount',
    YEAR: 'calculator_hypothec_type_year',
}

export const REPAYMENT_TYPES = {
    ANNUITY: 'calculator_repayment_type_annuity',
    DIFFERENTIATED: 'calculator_repayment_type_differentiated',
}

export const DEFAULT_ADDRESS = {
    lat: 40.208370,
    lng: 44.525650
};
export const MAP_DEFAULT_ZOOM = 15;


export const HOUSE_BADGES = {
    fixed: {
        key: "6012c054b88dc494783275c5",
        title: "Ամրագրված է"
    },
    sold: {
        key: "6012c054b88dc494783275c6",
        title: "Վաճառված է",
    },
    available: {
        key: "600ab6e5e503271f1c8ebcd0",
        title: "Առկա է"
    },
};

export const SOLD_IMAGES = {
    hy: sold_hy,
    ru: sold_ru,
    en: sold_en,
};

export const ROOM_COUNTS = [3,4];
export const AREA_NUMBERS = [169,187,195];

export const RESERVE_MODAL_TITLE_TYPES = {
    success: "success",
    error: "error",
    title: "title",
}
export const BUILDINGS_BADGE_TYPES = {
    booked: "6012c054b88dc494783275c5",
    sold: "6012c054b88dc494783275c6",
    available: "600ab6e5e503271f1c8ebcd0",
}

export const PROJECT_ID = {
    id: "628385aa0a9d6332a0f4e80e"
}
export const CURRENCY = ['USD_AMD', 'EUR_AMD', 'RUB_AMD']

export const AREA_TYPES = {
    APARTMENT: {
        title: 'area_type_apartment',
        filter_page_title: 'filter_apartment',
        key: 'APARTMENT',
    },
    OFFICE: {
        title: 'area_type_office',
        filter_page_title: 'filter_commerce',
        key: 'OFFICE',
    },
    // PARKING: {
    //     title: 'area_type_perking',
    //     filter_page_title: 'filter_parking',
    //     key: 'PARKING',
    // },
    // RESTAURANT: {
    //     title: 'area_type_restaurant',
    //     filter_page_title: 'filter_restaurant',
    //     key: 'RESTAURANT',
    // },
};

export const PROJECT_LINK = {
    // iconUrl: 'http://173.212.233.220:9200/files/ic-map.svg',
    iconUrl: 'https://rgconstruction.am/files/ic-map.svg',
    url:  "https://rgconstruction.am",
    // url:  process.env.REACT_APP_WEB_ENVIRONMENT === 'production' ? '' : "http://rg.4steps.am",
}

export const WORKS_TYPES = [
    {
        key:'all',
        title:'works_all_projects_type'
    },
    {
        key:'completed',
        title:'works_finished_projects_type'
    },
    {
        key:'current',
        title:'works_not_finished_projects_type'
    },
]


